import { Injectable } from "@angular/core";

import { Observable, Subject } from "rxjs";

import { NotificationPaneModel } from "./notification-pane.model";

@Injectable()
export class NotificationPaneService {
    private _notificationToShow = new Subject<NotificationPaneModel>();
    private _notificationToHide = new Subject<NotificationPaneModel>();

    public get notificationToShow(): Observable<NotificationPaneModel> {
        return this._notificationToShow.pipe();
    }

    public get notificationToHide(): Observable<NotificationPaneModel> {
        return this._notificationToHide.pipe();
    }

    public showInfo(title: string, text: string): void {
        this.show("success", title, text);
    }

    public showWarning(title: string, text: string): void {
        this.show("warning", title, text);
    }

    public showError(title: string, text: string): void {
        this.show("error", title, text);
    }

    public show(type: string, title: string, text: string): void {
        this._notificationToShow.next(new NotificationPaneModel(type, title, text));
    }

    public hide(notification: NotificationPaneModel): void {
        this._notificationToHide.next(notification);
    }
}
